/**
 * Data Transfer Object (DTO) for project billing model.
 * Represents the wire format used by the backend API.
 */

/**
 * Base DTO enum for project billing model.
 * Matches backend enum values exactly.
 */
export enum ProjectBillingModelDTO {
  FIXED_PRICE = 'FIXED_PRICE',
  TIME_AND_MATERIALS = 'TIME_AND_MATERIALS',
  NON_BILLABLE = 'NON_BILLABLE',
}

/**
 * Type alias for project billing model in API requests.
 */
export type ProjectBillingModelRequest = ProjectBillingModelDTO;

/**
 * Type alias for project billing model in API responses.
 */
export type ProjectBillingModelResponse = ProjectBillingModelDTO;
